/**
 * ContentEventSymbol.js
 *
 * Enumerates all events of the content FSM.
 *
 * Copyright (c) apploft. GmbH
 */

const failedItemsRequest = Symbol('failed to fetch list items');
const itemsReceived = Symbol('items successfully received');
const failedItemRequest = Symbol('failed to fetch item for editing');
const itemReceived = Symbol('item for editing successfully received');
const form = Symbol('present form');
const formResponseReceived = Symbol('received response for submitted form');
const failedFormSubmission = Symbol('failed to submit form');
const submitForm = Symbol('submit form');
const submitEditForm = Symbol('submit form for editing an item');
const selectSection = Symbol('select API section');
const editItem = Symbol('edit item');
const deleteItem = Symbol('delete item');

export {
  failedItemsRequest,
  itemsReceived,
  form,
  formResponseReceived,
  failedFormSubmission,
  submitForm,
  selectSection,
  editItem,
  submitEditForm,
  deleteItem,
  failedItemRequest,
  itemReceived,
};
